export enum PaymentMethodType {
  CARD = 'card',
  CASH_APP = 'cashapp',
  AMAZON_PAY = 'amazon_pay'
}

export interface PaymentMethod {
  type: PaymentMethodType;
  details?: {
    brand: string;
    last4: string;
    expMonth: number;
    expYear: number;
  };
}
